export default __webpack_public_path__ + "static/media/KOD0109-min.6148c434.webp";